import LabelName from 'components/UI/LabelName/LabelName';
import { getSignedUrl } from 'modules/file_manager/services';
import React, { useEffect, useState } from 'react';

export default function PreviewSignature({ item }) {
  const [image, setImage] = useState('');

  const imageURl = async () => {
    setImage(await getSignedUrl({ file_path: item.value }));
  };

  useEffect(() => {
    imageURl();
  }, []);

  return (
    <div>
      <LabelName>Client Signature</LabelName>
      <img src={image} alt="Signature" style={{ height: '150px', maxWidth: '100%', width: 'unset' }} />
    </div>
  );
}
